module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "train_evalItem"
  }, [_c('div', {
    staticClass: "board pointer",
    class: {
      'pic-mode': _vm.isModal
    },
    staticStyle: {
      "position": "relative"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("card", [_c('img', {
    attrs: {
      "src": _vm.itemImage
    }
  })]), _vm._v(" "), (_vm.showIndicator) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "bottom": "0px",
      "left": "0px",
      "right": "0px",
      "background": "rgba(0, 0, 0, 0.3)",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_vm._t("indicator")], 2) : _vm._e()], 2), _vm._v(" "), _vm._t("title", [_c('div', [_vm._v(_vm._s(_vm.itemTitle))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8feb9f26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/foundation/ui/controls/card-list-item/component.vue
// module id = 1015
// module chunks = 2